import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userBookDoc: [],//关联挂号医生列表
    currUserBookDoc: {},//当前挂号医生
    //远程会诊
    currentBindDocLists:[],//当前登陆用户绑定的医生列表
    currentBindDoc:{},//当前选择的医生
    currentBindDepLists:[],//当前登陆用户绑定的科室列表
    currentBindDep:{},//当前选择的科室
    currentType:"1",//当前类型 1 专家  2 普通
  },
  mutations: {
    setUserBookDoc(state, payload) {
      state.userBookDoc = payload;
    },
    setCurrUserBookDoc(state, payload) {
      state.currUserBookDoc = payload;
    },
    //远程会诊
    setCurrentBindDoc(state, payload) {
      state.currentBindDoc = payload;
    },
    setCurrentBindDocLists(state, payload) {
      state.currentBindDocLists = payload;
    },
    setCurrentBindDep(state, payload) {
      state.currentBindDep = payload;
    },
    setCurrentBindDepLists(state, payload) {
      state.currentBindDepLists = payload;
    },
    setCurrentType(state, payload){
      state.currentType = payload;
    }
  }
})
